import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminBoxQuestionnaireQuestionOptionResponse } from './admin-box-questionnaire-question-option.response';

@jsonObject
export class AdminBoxQuestionnaireQuestionResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly description?: Nillable<string>;

  @jsonArrayMember(AdminBoxQuestionnaireQuestionOptionResponse)
  public readonly options!: AdminBoxQuestionnaireQuestionOptionResponse[];
}
